<template>
  <div class="week-fast-news-list-item">
    <div class="week-fast-news-list-item-detail">
      <div class="week-fast-news-list-item-title">{{data.title}}</div>
      <div class="week-fast-news-list-item-abstract">{{data.content}}</div>
      <div class="week-fast-news-list-item-abstract-time">{{data.time}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'week-fast-news-list-item',
  props: {
    data: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
  .week-fast-news-list-item {
    position: relative;
    padding: 18px 0 18px 23px;
    border-left: 2px solid #f7f7fa;
    .week-fast-news-list-item-detail {
      padding: 4px;
      .week-fast-news-list-item-title {
        margin-bottom: 4px;
        color: #171f46;
        font-size: 14px;
      }
      .week-fast-news-list-item-abstract {
        line-height: 18px;
        color: #747990;
        font-size: 12px;
      }
      .week-fast-news-list-item-abstract-time {
        position: absolute;
        top: 22px;
        left: -15px;
        width: 28px;
        height: 17px;
        line-height: 17px;
        text-align: center;
        color: #747990;
        background-color: #ffffff;
        font-size: 12px;
      }
    }
  }
</style>

